export const STATUS_COLORS = [
    'NEUTRAL',
    'ORANGE',
    'YELLOW',
    'LIME',
    'GREEN',
    'TEAL',
    'CYAN',
    'BLUE',
    'INDIGO',
    'PURPLE',
    'VIOLET',
    'PINK',
    'RED',
];
export const getStatusColorTranslationKey = (color) => `status_color_${color.toLowerCase()}`;
export const getStatusColorVar = (color) => color ? `var(--status-color-${color.toLowerCase()})` : undefined;
